// @ts-nocheck

import type { App } from 'vue';
import html2canvas from 'html2canvas';
import { jsPDF } from 'jspdf';

import dayjs from 'dayjs';
import dayjsPluginUTC from 'dayjs-plugin-utc';
dayjs.extend(dayjsPluginUTC);

export function loadPrototypes(app: App) {
  app.config.globalProperties.$filters = {
    lowercase(value: any) {
      if (!value) return '';
      return value.toLowerCase();
    },
    num2CommaSaparatedKES(value: any) {
      if (!value) return '';
      return value
        .toString()
        .split([''])
        .reverse()
        .join('')
        .match(/.{1,3}/g)
        .join(',')
        .split('')
        .reverse()
        .join('');
    },
    dateUTCToLocalTime(value: any) {
      if (!value) return '';
      return ` ${dayjs.utc(value.substring(0, 23)).local().format('DD MMM YYYY HH:mm')}`;
    },
    formatNumber(num, maximumFractionDigits) {
      return Intl.NumberFormat('en-US', {
        notation: 'compact',
        maximumFractionDigits: maximumFractionDigits,
      }).format(num);
    },
  };

  app.config.globalProperties.$scrollToTop = () => window.scrollTo(0, 0);

  app.config.globalProperties.$saveAs = (uri, filename) => {
    const link = document.createElement('a');

    if (typeof link.download === 'string') {
      link.href = uri;
      link.download = filename;

      // Firefox requires the link to be in the body
      document.body.appendChild(link);

      // simulate click
      link.click();

      // remove the link when done
      document.body.removeChild(link);
    } else {
      window.open(uri);
    }
  };

  app.config.globalProperties.$download = (ref, downloadType, filename) => {
    const { clientWidth } = ref;
    const { clientHeight } = ref;

    html2canvas(ref, {
      scrollX: 0,
      scrollY: window.pageYOffset * -1,
    }).then(canvas => {
      const img = canvas.toDataURL('image/jpeg', 1);
      if (downloadType === 'pdf') {
        // eslint-disable-next-line new-cap
        const doc = new jsPDF('p', 'pt', [clientWidth, clientHeight]);
        doc.addImage(img, 'PNG', 0, 0, clientWidth, clientHeight);
        doc.save(filename);
      } else {
        app.config.globalProperties.$saveAs(img, filename);
      }
    });
  };
}
